module.exports = __webpack_public_path__ + "static/img/develop-banner4.3e011554.png";